export default __webpack_public_path__ + "static/media/benefit_16.99697a0c.png";